// SPDX-License-Identifier: MIT
/**
 * Closed-form damped spring from 0 to 1, evaluated at time `t` seconds after release.
 * Being closed-form keeps scenes a pure function of time (no integration state between frames).
 */
export function spring(t: number, { stiffness = 170, damping = 18, mass = 1 } = {}): number {
    if (t <= 0)
        return 0;
    const w0 = Math.sqrt(stiffness / mass);
    const zeta = damping / (2 * Math.sqrt(stiffness * mass));
    if (zeta < 1) {
        const wd = w0 * Math.sqrt(1 - zeta * zeta);
        return 1 - Math.exp(-zeta * w0 * t) * (Math.cos(wd * t) + ((zeta * w0) / wd) * Math.sin(wd * t));
    }
    // Critically/over-damped: use the critically damped form (stable, monotonic).
    return 1 - Math.exp(-w0 * t) * (1 + w0 * t);
}
